import React from 'react';
import cn from 'classnames';
import styles from '@app/case/index.module.less';
import Image from '@base/lib/ThemeImage';

const CasePage: Globals.NextPage = () => {
    return (
        <>
            <div className={styles.case}>
                <h1 className={cn(styles.title, 'g-font-exp-bold')}>645W LED +1000W HPS GROW SERIES-PLATINUM OG</h1>
                <div className={styles.place}>Indoor</div>

                <Image
                    src="asset/width-1542/picture/a6bd116b6d5b9de945af2b1118218135.jpg"
                    width={1542}
                    height={1300}
                    background={false}
                />
                <div className={styles.desc}>
                    These lights have been excellent for our plants. Great quality with exceptional results. We will definitely be purchasing more—Flexstar has been a fantastic partner with beautiful lights.
                </div>
            </div>
        </>
    )
};

CasePage.pageConf = {
    bodyClassName: styles.body
};

export default CasePage;

